import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import Hero from '../sections/Hero';
import Features from '../sections/Features';
import Games from '../sections/Games';
import ProvablyFair from '../sections/ProvablyFair';
import CTA from '../sections/CTA';
import styles from './LandingPage.module.css';

export default function LandingPage() {
	return (
		<div className={styles.page}>
			<Navigation />
			<main className={styles.main}>
				<Hero />
				<Features />
				<Games />
				<ProvablyFair />
				<CTA />
			</main>
			<Footer />
		</div>
	);
}
